<div>
  @if (busy) {
    <app-mat-spinner-overlay  [overlay]="true"></app-mat-spinner-overlay>
  }
  <h2 mat-dialog-title>{{title}}</h2>
  <mat-dialog-content>
    <div class="flex-col justify-start items-stretch my-3" [formGroup]="dialogForm" >
      <mat-form-field class="w-100"  appearance="outline">
        <mat-label>Amount</mat-label>
        <span matTextPrefix>$&nbsp;</span>
        <input matInput formControlName="usagePrice" type="number" required min="0">
        @if (dialogForm.controls.usagePrice.errors?.required) {
          <mat-error>Amount is required</mat-error>
        }
        @if (dialogForm.controls.usagePrice.errors?.min) {
          <mat-error>Amount cannot be negative</mat-error>
        }
      </mat-form-field>
    </div>
  </mat-dialog-content>
</div>
<mat-dialog-actions>
  <div class="mt-3 p-2 w-100 flex-row space-between items-center">
    <a mat-button color="primary" (click)="onCancelClick()">{{cancelButtonText}}</a>
    <button mat-flat-button color="primary" [disabled]="!canSubmit" (click)="onSubmitClick()">{{submitButtonText}}</button>
  </div>
</mat-dialog-actions>